import { Box, Grid } from '@chakra-ui/react'

import DesignCard from './design-card'

import type { Design } from '@/api/designs'

interface LargeCardsGridProps {
  designs: Design[]
  onImageClick: (design: Design) => void
  onToggleFavorite: (designId: string, isFavorite: boolean) => void
}

export default function LargeCardsGrid({
  designs,
  onImageClick,
  onToggleFavorite
}: LargeCardsGridProps) {
  return (
    <Box px={{ base: '16px', md: '24px' }}>
      <Grid
        templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
        gap="24px"
      >
        {designs.map((design, index) => (
          <DesignCard
            key={design.id}
            design={design}
            index={index}
            columnsPerRow={2}
            layoutMode="large"
            onImageClick={onImageClick}
            onToggleFavorite={onToggleFavorite}
          />
        ))}
      </Grid>
    </Box>
  )
}
